/* eslint-disable @typescript-eslint/no-unsafe-call */

import { IM, useLanguage, useTheme } from '@infominds/react-native-components'
import { useAuthentication } from '@infominds/react-native-license'
import Moment from 'moment'
import React, { useEffect, useState } from 'react'
import { FlatList, Platform, StyleSheet } from 'react-native'
import Spinner from 'react-native-modal-spinner'

import api from '../apis/Api'
import { Text, TextInput, TouchableHighlight, TouchableOpacity, View } from '../components/Themed'
import Colors from '../constants/Colors'
import { DelegateScreenNavigationProp } from '../types'

export default function DelegateScreen({ route, navigation }: DelegateScreenNavigationProp) {
  const { i18n } = useLanguage()
  const { colorScheme } = useTheme()
  const { url, token, company } = useAuthentication()
  const { bill } = route.params

  const [search, updateSearch] = useState('')
  const [employees, setEmployees] = useState([])
  const [refreshing, setRefreshing] = useState(true)
  const [loading, setLoading] = useState(false)

  const load = () =>
    api
      .getEmployees(token, url, company)
      .then(result => {
        // @ts-expect-error: ok
        setEmployees(result)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => setRefreshing(false))

  useEffect(() => {
    load().catch(console.error)
  }, [url, token, company])

  const delegate = (item: { id: number }) => {
    setLoading(true)

    new Promise((resolve, reject) => {
      api
        .delegate(token, url, company, bill.msgId, bill.billID, bill.supplierID, bill.billDate, item.id, bill.comment)
        .then(result => {
          console.debug('DELEGATE', result)
          resolve(result)
          navigation.navigate('TabHomeScreen')
        })
        .catch(error => {
          console.error(error)
          reject(error)
        })
    })
      .catch(console.error)
      .finally(() => setLoading(false))
  }

  const renderItem = ({ item }: any) => {
    return (
      <TouchableHighlight
        onPress={() => delegate(item)}
        // eslint-disable-next-line react-native/no-inline-styles
        style={{ margin: 1 }}
        lightColor={Colors.light.listItemBackground}
        darkColor={Colors.dark.listItemBackground}>
        <View style={styles.item} lightColor={Colors.light.listItemBackground} darkColor={Colors.dark.listItemBackground}>
          <Text lightColor={Colors.light.text} darkColor={Colors.dark.text}>
            {item.firstName} {item.lastName}
          </Text>
        </View>
      </TouchableHighlight>
    )
  }

  return (
    <View style={styles.root}>
      {Platform.OS !== 'web' ? <Spinner color={Colors.tint} size="large" backgroundColor="transparent" visible={loading} /> : <></>}

      <View style={styles.container}>
        <View style={styles.left}>
          <Text style={styles.header}>{bill.supplierName}</Text>
          <View style={styles.detail}>
            <Text>
              {i18n.t('ID_BILLNR')} {bill.billID} {i18n.t('ID_FROM')} {Moment(bill.billDate).format('DD/MM/yyyy')}
            </Text>
            <Text>
              {bill.billAmount} {bill.currency}
            </Text>
          </View>
        </View>
        <View style={styles.right}>
          <TouchableOpacity onPress={() => navigation.navigate('PreviewScreen', { bill: bill })}>
            <IM.Icon size={28} icon={['far', 'file']} color={colorScheme === 'light' ? '#000000' : '#ffffff'} />
          </TouchableOpacity>
        </View>

        <TextInput
          lightColor={Colors.light.listItemBackground}
          darkColor={Colors.dark.listItemBackground}
          placeholder="Search..."
          // eslint-disable-next-line react-native/no-inline-styles
          style={[styles.input, { color: colorScheme === 'light' ? '#000000' : '#ffffff' }]}
          onChangeText={updateSearch}
          value={search}
        />

        <FlatList
          // @ts-ignore todo
          data={employees.filter(item => item.firstName.toLowerCase().includes(search.toLowerCase()))}
          renderItem={renderItem}
          onRefresh={() => {
            load().catch(console.error)
          }}
          refreshing={refreshing}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  container: {
    padding: 20,
  },
  left: {
    width: '70%',
  },
  right: {
    alignSelf: 'flex-end',
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  detail: {
    marginBottom: 20,
  },
  item: {
    margin: 2,
    padding: 10,
    fontSize: 18,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  input: {
    margin: 2,
    marginBottom: 10,
    marginTop: 10,
    paddingLeft: 10,
    padding: 12,
    borderWidth: 0,
    borderRadius: 5,
  },
})
